import { useState, useRef, useLayoutEffect, Fragment } from 'react';
import { TableRow } from '../TableRow/TableRow.js';
import { StyledTableBodyCell, TableCollapseRow, TableCollapseBodyCell } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { TableRowCollapseButton } from './components/TableRowCollapseButton/TableRowCollapseButton.js';

function TableRowCollapse(props) {
  var children = props.children,
    colSpan = props.colSpan,
    dropdownContent = props.dropdownContent,
    expandibleHeaders = props.expandibleHeaders,
    hideDropdownOnBreakpoint = props.hideDropdownOnBreakpoint;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var buttonRef = useRef(null);
  var _useState2 = useState(0),
    buttonWidth = _useState2[0],
    setButtonWidth = _useState2[1];
  useLayoutEffect(function () {
    var _a;
    var _ref = ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 0 : _ref$width;
    setButtonWidth(width);
  }, []);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(TableRow, {
      $expanded: open,
      children: [/*#__PURE__*/jsx(StyledTableBodyCell, {
        $hideOnBreakpoint: hideDropdownOnBreakpoint,
        headers: expandibleHeaders,
        children: /*#__PURE__*/jsx(TableRowCollapseButton, {
          ref: buttonRef,
          open: open,
          onClick: function onClick() {
            return setOpen(!open);
          }
        })
      }), children]
    }), open && /*#__PURE__*/jsx(TableCollapseRow, {
      $hideOnBreakpoint: hideDropdownOnBreakpoint,
      children: /*#__PURE__*/jsx(TableCollapseBodyCell, {
        $offset: buttonWidth,
        headers: expandibleHeaders,
        colSpan: colSpan,
        children: dropdownContent
      })
    })]
  });
}

export { TableRowCollapse };
